export const handleDownloadImage = (imageUrl, nameImage) => {
    // Créer un élément <a> pour télécharger l'image
    const link = document.createElement('a');
    link.href = imageUrl; // URL de l'image
    link.target = "_blank"; // URL de l'image
    link.download = `${nameImage}.jpg`; // Nom du fichier téléchargé
    document.body.appendChild(link);
    link.click(); // Simuler un clic sur le lien
    document.body.removeChild(link); // Supprimer le lien après téléchargement
};